<template>
	<ul class="sign-progress hidden-xs-only">
		<li class="steps" :class="{'step-active':current >= 1}">
			<p class="num">1</p>
			<p class="en">step 1</p>
			<p class="ch">填写信息</p>
		</li>
		<li class="steps" :class="{'step-active':current >= 2}">
			<p class="num">2</p>
			<p class="en">step 2</p>
			<p class="ch">在线支付</p>
		</li>
		<li class="steps" :class="{'step-active':current >= 3}">
			<p class="num">3</p>
			<p class="en">step 3</p>
			<p class="ch">报名成功</p>
		</li>
	</ul>
</template>
<script>
export default {
    props:{
        current:{
            type:[Number,String],
            default:1
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.sign-progress {
	width: 70%;
	position: relative;
	overflow: hidden;
	margin-bottom: 65px;
	padding-bottom: 20px;
	margin: 40px auto 0;
	display: flex;
	.steps {
		flex: 1;
		position: relative;
		z-index: 2;
		.num {
			width: 36px;
			height: 36px;
			border-radius: 50%;
			background: #bfbfbf;
			text-align: center;
			line-height: 36px;
			font-size: 20px;
			color: #fff;
			margin: 0 auto;
		}
		.en {
			font-size: 12px;
			text-align: center;
			margin-top: 10px;
			color: #8a8a8a;
		}
		.ch {
			font-size: 16px;
			color: #949494;
			margin-top: 5px;
			text-align: center;
		}
		&.step-active {
			.num {
				background: $--color-red;
            }
            .en{
                color: #000;
            }
            .ch{
                color: #000;
            }
		}
	}
	&::after {
		content: "";
		display: block;
		width: 100%;
		height: 3px;
		background: #bfbfbf;
		position: absolute;
		top: 18px;
		z-index: 1;
	}
}
</style>
